import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
  withStyles,
} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import React, { Component } from "react";
import { connect } from "react-redux";
import { appService } from "../../App/app.service";
import D3RepPerformanceBarWins from "../RepPerformanceAnalysis/Charts/D3RepPerformanceBarFYWins";
import Legend from "../AsOfDate/Legend";
import D3RepPerformanceStack from "../RepPerformanceAnalysis/Charts/D3RepPerformanceStack";
import {
  getUniqueValues,
  getDefaultSelectedFiscalQuarters,
} from "../../util/customFunctions";
import C0001_TeamAttainmentTable from "./C0001_TeamAttainmentTable";
import Drilldown from "../RepCertification/Drilldown";
import SingleLevelDrilldown from "../../components/Drilldown/SingleLevelDrilldown";
import TeamAttainmentDrilldown from "./TeamAttainmentDrilldown";
import ExpectedAcvPage from "../../EnhancedInsights/NewWaterFall/ExpectedAcvPage";
import TeamFilterHierarchy from "../../components/team-filter-hirarchy";
import ExportPPtx from "../../components/ExportPPT";
import AddHeaderDescriptionWithHelperText from "../../components/HelperTextDescription";

const styles = (theme) => ({
  root: {},
  content: {},
  buttons: {
    display: "flex",
    justifyContent: "center",
    "& > *": {
      marginLeft: theme.spacing(1),
    },
  },
  table: {
    border: "0.5px solid lightgrey",
    padding: "5px 10px",
    color: "inherit",
  },
  table1: {
    background: "#FAFAFA",
    border: "none",
    width: 5,
  },
  rep: {
    border: "0.5px solid lightgrey",
    padding: "0px 10px",
    width: "20%",
    color: "inherit",
  },
  tableHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "0px 10px",
    color: "white",
    background: "#4472C4",
  },
  repHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "0px 5px",
    width: "20%",
    color: "inherit",
  },
  datesFilterContainer: {
    marginTop: 5,
    marginRight: 5,
    marginBottom: 5,
    padding: 10,
    paddingBottom: 10,
    width: "32%",
    [theme.breakpoints.down("md")]: {
      width: "60%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  mainTable: {
    width: "100%",
    maxWidth: "100%",
    [theme.breakpoints.up(1250)]: {
      width: 1000,
    },
    [theme.breakpoints.up(1900)]: {
      width: 1400,
    },
  },
  mainTable2: {
    width: "100%",
    maxWidth: "100%",
    [theme.breakpoints.up(1250)]: {
      width: 800,
    },
    [theme.breakpoints.up(1900)]: {
      width: 1200,
    },
  },
});
class TeamAttainmentCleo extends Component {
  Contribution = React.createRef();
  Performance = React.createRef();

  filters = [
    "closed_fiscal_quarter",
    "closed_fiscal_year",
    "team",
    "Opportunity_Record_Type",
  ];
  state = {
    Opportunity_Record_Type: ["All"],
    year: ["all"],
    month: ["all"],
    quarter: ["all"],
    closed_fiscal_quarter: ["All"],
    closed_fiscal_year: ["All"],
    disabled: ["year", "month", "quarter"],
    activeTimeFilter: "closed_fiscal_quarter",
    team: ["All"],
    drilldownFilters: [],
    key: "",
    secondLevelLocation: null,
  };
  componentDidMount = () => {
    this.props.getTeamAttainmentCleoFilters();
    window.addEventListener("resize", this.onResize);
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.props.funnelCompareFilters !== "" &&
      prevProps.funnelCompareFilters === ""
    ) {
      const currentQuarter = getDefaultSelectedFiscalQuarters(
        this.props.funnelCompareFilters,
        "closed_fiscal_quarter"
      );

      //Set team filter default value
      let defaultvalueTeam;

      if (this.props.funnelCompareFilters !== "") {
        const val = this.props.funnelCompareFilters.find((filter) =>
          filter.hasOwnProperty("parentChildrenTeamFilter")
        );
        defaultvalueTeam = val.parentChildrenTeamFilter.defaultValueTeam;
      }
      this.setState({
        ...prevState,
        team: defaultvalueTeam ? defaultvalueTeam : ["All"],
        closed_fiscal_quarter: currentQuarter,
        key: "closed_fiscal_quarter",
      });
    }
    if (this.props.SegmentPerformanceData !== "") {
      D3RepPerformanceBarWins.destroy(this._rootNode1);
      D3RepPerformanceStack.destroy(this._rootNode2);
      this._chart1 = D3RepPerformanceBarWins.create(this._rootNode1, {
        data: this.props.SegmentPerformanceData,
        type: "Segment",
      });
      this._chart2 = D3RepPerformanceStack.create(this._rootNode2, {
        data: this.props.SegmentPerformanceData,
        type: "Segment",
      });
    }
  };
  componentWillUnmount = () => {
    window.removeEventListener("resize", this.onResize);
    D3RepPerformanceBarWins.destroy(this._rootNode1);
  };
  onResize = async () => {
    D3RepPerformanceBarWins.destroy(this._rootNode1);
    D3RepPerformanceStack.destroy(this._rootNode2);
    this._chart1 = D3RepPerformanceBarWins.create(this._rootNode1, {
      data: this.props.SegmentPerformanceData,
      type: "Segment",
    });
    this._chart2 = D3RepPerformanceStack.create(this._rootNode2, {
      data: this.props.SegmentPerformanceData,
      type: "Segment",
    });
  };
  _setRef1(componentNode) {
    this._rootNode1 = componentNode;
  }
  _setRef2(componentNode) {
    this._rootNode2 = componentNode;
  }
  handleChange = (e) => {
    if (
      e.target.name === "closed_fiscal_year" &&
      (e.target.value.length === 0 || e.target.value.includes("All"))
    ) {
      this.setState({
        ...this.state,
        [e.target.name]:
          e.target.value.length === 0
            ? ["All"]
            : this.state[e.target.name].length === 1 &&
              this.state[e.target.name].includes("All")
            ? e.target.value.filter((v) => v !== "All").length > 0
              ? e.target.value.filter((v) => v !== "All")
              : ["All"]
            : e.target.value.includes("All")
            ? ["All"]
            : e.target.value,
        activeTimeFilter: "closed_fiscal_year",
      });
    } else if (e.target.name === "closed_fiscal_year") {
      this.setState({
        ...this.state,
        [e.target.name]:
          e.target.name === "rep"
            ? [e.target.value]
            : e.target.value.length === 0
            ? ["All"]
            : this.state[e.target.name].length === 1 &&
              this.state[e.target.name].includes("All")
            ? e.target.value.filter((v) => v !== "All").length > 0
              ? e.target.value.filter((v) => v !== "All")
              : ["All"]
            : e.target.value.includes("All")
            ? ["All"]
            : e.target.value,
        activeTimeFilter: "closed_fiscal_year",
      });
    } else if (e.target.name === "closed_fiscal_quarter") {
      this.setState({
        ...this.state,
        [e.target.name]:
          e.target.name === "rep"
            ? [e.target.value]
            : e.target.value.length === 0
            ? ["All"]
            : this.state[e.target.name].length === 1 &&
              this.state[e.target.name].includes("All")
            ? e.target.value.filter((v) => v !== "All").length > 0
              ? e.target.value.filter((v) => v !== "All")
              : ["All"]
            : e.target.value.includes("All")
            ? ["All"]
            : e.target.value,
        activeTimeFilter: "closed_fiscal_quarter",
      });
    } else {
      this.setState({
        ...this.state,
        [e.target.name]:
          e.target.name === "rep"
            ? [e.target.value]
            : e.target.value.length === 0
            ? ["All"]
            : this.state[e.target.name].length === 1 &&
              this.state[e.target.name].includes("All")
            ? e.target.value.filter((v) => v !== "All").length > 0
              ? e.target.value.filter((v) => v !== "All")
              : ["All"]
            : e.target.value.includes("All")
            ? ["All"]
            : e.target.value,
      });
    }
  };

  handleChangeNew = (filteredValues) => {
    this.setState({
      ...this.state,
      team:
        this.state.team.length === 1 && this.state.team.includes("All")
          ? filteredValues.filter((v) => v !== "All").length > 0
            ? filteredValues.filter((v) => v !== "All")
            : ["All"]
          : filteredValues.includes("All")
          ? ["All"]
          : filteredValues,
    });
  };

  handleGo = () => {
    localStorage.removeItem("skygeni-auto-update");
    let filters = this.filters
      .map((f) => {
        return {
          name: f,
          value:
            f === "rep"
              ? this.state[f].includes("All")
                ? "All"
                : this.getSelectedRepIDs()
              : this.state[f],
          string: true,
        };
      })
      .filter(
        (f) =>
          (!Array.isArray(f.value) && f.value !== "All") ||
          !f.value.includes("All")
      )
      .filter((f) => !this.state.disabled.includes(f.name));

    let key = "";
    if (this.state.closed_fiscal_year.includes("All")) {
      key = "closed_fiscal_quarter";
    } else {
      key = "closed_fiscal_year";
    }

    this.props.getTeamAttainmentCleoData(filters, key);
    this.setState({ key });
  };

  handleChangeLocationBack = () => {
    this.setState({
      location: "",
      secondLevelLocation: "",
    });
  };

  handleChangeLocation = (location, quarter, team) => {
    if (location === "drilldownOnGraph") {
      let filters = [];
      let drilldownFilters = [];
      let qtr = quarter;
      if (this.state.key === "closed_fiscal_year") {
        qtr = quarter.map((c) => parseInt(c));
      }
      filters = [
        { name: this.state.key, value: qtr, string: true },
        { name: "team", value: team, string: true },
      ];
      drilldownFilters = [
        {
          title:
            this.state.key === "closed_fiscal_year"
              ? "Fiscal Year"
              : "Fiscal Qtr.",
          value: quarter,
        },
        { title: "Team", value: team },
      ];
      this.props.getTeamAttainmentCleoDrilldown(filters);
      this.setState({
        location,
        drilldownFilters,
        secondLevelLocation: location,
      });
    } else {
      this.props.clearDrilldownData();
    }
  };

  handleSecondLevelDrilldown = (location, oppId) => {
    console.log(oppId);
    this.setState({
      ...this.state,
      secondLevelLocation: location,
    });
    this.props.getOpenOppData(oppId);
  };

  stepBack = () => {
    this.setState({
      ...this.state,
      secondLevelLocation: "",
    });
    this.props.clearExpectedAcvData();
  };

  render() {
    const { classes } = this.props;

    let teamObject;
    if (this.props.funnelCompareFilters !== "") {
      teamObject = this.props.funnelCompareFilters.find((filter) =>
        filter.hasOwnProperty("parentChildrenTeamFilter")
      );
    }

    return (
      <Grid container className={classes.gridContainer}>
        <AddHeaderDescriptionWithHelperText
          header={`Team Attainment (Cleo)`}
          description={`Explore the historical performance by segment teams with ELV Quota.`}
          helperTextCharts={this.props.helperTextCharts}
        />

        {this.props.funnelCompareFilters !== "" &&
        this.props.funnelCompareFilters !== undefined ? (
          <Grid
            className={classes.grid}
            item
            container
            justify="flex-start"
            spacing={2}
            xs={12}
            style={{ margin: 10, padding: 15 }}
          >
            <Grid item spacing={2} xs={4} container component={Paper}>
              <Grid item xs={6} style={{ paddingTop: 0 }}>
                <FormControl
                  fullWidth
                  disabled={!this.state.closed_fiscal_year.includes("All")}
                >
                  <InputLabel
                    style={{
                      color: !this.state.closed_fiscal_quarter.includes("All")
                        ? "#4472c4"
                        : "#000",
                    }}
                    id="select-vfiscalQuarter-label"
                  >
                    Fiscal Qtr.:
                  </InputLabel>
                  <Select
                    labelId="select-vRenewal_Contract_Eff_Dt_Fiscal_Quarter-label"
                    id="select-cclosed_fiscal_quarter"
                    value={this.state.closed_fiscal_quarter}
                    onChange={this.handleChange}
                    label="closed_fiscal_quarter"
                    name="closed_fiscal_quarter"
                    data-test="closed-fiscal-quarter"
                    multiple
                  >
                    <MenuItem value={"All"}>All</MenuItem>
                    {this.props.funnelCompareFilters !== "" &&
                      this.props.funnelCompareFilters
                        .filter(
                          (y) =>
                            y.type === "closed_fiscal_quarter" &&
                            y["closed_fiscal_quarter"] !== "" &&
                            y["closed_fiscal_quarter"] !== null
                        )
                        .map((y) => (
                          <MenuItem
                            key={y["closed_fiscal_quarter"]}
                            value={y["closed_fiscal_quarter"]}
                          >
                            {y["closed_fiscal_quarter"]}
                          </MenuItem>
                        ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} style={{ paddingTop: 0 }}>
                <FormControl
                  fullWidth
                  disabled={!this.state.closed_fiscal_quarter.includes("All")}
                >
                  <InputLabel
                    style={{
                      color: !this.state.closed_fiscal_year.includes("All")
                        ? "#4472c4"
                        : "#000",
                    }}
                    id="select-vfiscalQuarter-label"
                  >
                    Fiscal Year:
                  </InputLabel>
                  <Select
                    labelId="select-vprojected_close_fiscal_quarter-label"
                    id="select-cclosed_fiscal_year"
                    value={this.state.closed_fiscal_year}
                    onChange={this.handleChange}
                    label="closed_fiscal_year"
                    name="closed_fiscal_year"
                    data-test="closed-fiscal-year"
                    multiple
                  >
                    <MenuItem value={"All"}>All</MenuItem>
                    {this.props.funnelCompareFilters !== "" &&
                      this.props.funnelCompareFilters
                        .filter(
                          (y) =>
                            y.type === "closed_fiscal_year" &&
                            y["closed_fiscal_year"] !== "" &&
                            y["closed_fiscal_year"] !== null
                        )
                        .map((y) => (
                          <MenuItem
                            key={y["closed_fiscal_year"]}
                            value={y["closed_fiscal_year"]}
                          >
                            {y["closed_fiscal_year"]}
                          </MenuItem>
                        ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid
              item
              spacing={2}
              xs={2}
              container
              component={Paper}
              style={{ marginLeft: 15 }}
            >
              <Grid item xs={12} style={{ paddingTop: 0 }}>
                <TeamFilterHierarchy
                  label="Team:"
                  value={this.state.team}
                  data={teamObject.parentChildrenTeamFilter.filters}
                  onTeamChange={this.handleChangeNew}
                  name="team"
                  disabled={false}
                  labelColorCondition={!this.state.team.includes("All")}
                  renderValue={(selected) => selected.join(", ")}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.parentValue + option.label}
                />
              </Grid>
            </Grid>
            <Grid
              item
              sm={2}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleGo}
                data-test="go"
              >
                GO
              </Button>
            </Grid>
          </Grid>
        ) : (
          <Grid
            item
            container
            component={Card}
            style={{ margin: "1rem" }}
            justify="center"
          >
            <Skeleton
              variant="react"
              animation="wave"
              height={120}
              width="90%"
              style={{ margin: "1rem" }}
            />
          </Grid>
        )}
        <Grid item xs={12} container justify="center">
          <Grid
            align="center"
            component={Card}
            justify="center"
            item
            xs={12}
            id="grid-container"
            style={{
              marginBottom: 20,
              overflow: "auto",
              padding: "1rem",
              width: "100%",
            }}
          >
            {this.props.TeamAttainmentCleoData !== "" ? (
              <C0001_TeamAttainmentTable
                data={this.props.TeamAttainmentCleoData}
                handleChangeLocation={this.handleChangeLocation}
                Value_Label={this.props.Value_Label}
              />
            ) : (
              <Grid
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Skeleton
                  animation="wave"
                  variant="text"
                  width="80%"
                  style={{ margin: "20px 0px" }}
                />
                <Divider style={{ width: "100%" }} />
                <Skeleton
                  animation="wave"
                  variant="rect"
                  width="80%"
                  height={200}
                  style={{ margin: "20px 0px" }}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ margin: "1rem" }}>
          <Card style={{ margin: "auto", width: "88%" }} raised={true}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                margin: "1rem",
              }}
            >
              <Typography
                variant="h2"
                style={{
                  flexGrow: 1,
                  textAlign: "center",
                }}
              >
                Contribution to Total
              </Typography>
              <div style={{ marginRight: 20 }}>
                <ExportPPtx
                  chartRef={this.Contribution}
                  title={"Contribution to Total"}
                />
              </div>
            </div>
            {this.props.SegmentPerformanceData !== "" ? (
              <Grid container>
                <Grid item container xs={12} ref={this.Contribution}>
                  <div
                    style={{
                      justifyContent: "center",
                      marginTop: 20,
                      margin: "auto",
                      width: "95%",
                    }}
                    className="line-container"
                    ref={this._setRef2.bind(this)}
                  />
                </Grid>
              </Grid>
            ) : (
              <Skeleton
                animation="wave"
                variant="rect"
                width="95%"
                height={230}
                style={{ margin: "2rem" }}
              />
            )}
          </Card>
        </Grid>
        <Grid item xs={12} style={{ margin: "1rem" }}>
          <Card style={{ margin: "auto", width: "88%" }} raised={true}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                margin: "1rem",
              }}
            >
              <Typography
                variant="h2"
                style={{
                  flexGrow: 1,
                  textAlign: "center",
                }}
              >
                Performance - Actual vs. Quota
              </Typography>
              <div style={{ marginRight: 20 }}>
                <ExportPPtx
                  chartRef={this.Performance}
                  title={"Performance - Actual vs. Quota"}
                />
              </div>
            </div>

            {this.props.SegmentPerformanceData !== "" ? (
              <Grid container>
                <Grid item container xs={12} ref={this.Performance}>
                  <div
                    style={{
                      justifyContent: "center",
                      marginTop: 20,
                      margin: "auto",
                      width: "95%",
                    }}
                    className="line-container"
                    ref={this._setRef1.bind(this)}
                  />
                </Grid>
                <Grid
                  item
                  container
                  justify="center"
                  style={{ margin: "2rem" }}
                  xs={12}
                >
                  <Legend
                    square={20}
                    legends={[
                      { text: "Actual", color: "#70AD47" },
                      { text: "Quota", color: "#BF9000" },
                    ]}
                    type={"segment"}
                  />
                </Grid>
              </Grid>
            ) : (
              <Skeleton
                animation="wave"
                variant="rect"
                width="95%"
                height={230}
                style={{ margin: "2rem" }}
              />
            )}
          </Card>
        </Grid>
        {this.state.location === "drilldownOnGraph" && (
          <Grid
            item
            xs={12}
            style={{ position: "absolute", width: "100%", marginTop: "30px" }}
          >
            <SingleLevelDrilldown
              header={`Team Attainment (Cleo)`}
              back={this.handleChangeLocationBack}
              filters={this.state.drilldownFilters}
            >
              <Drilldown
                body={this.props.drilldownOnGraphData}
                company={this.props.company}
                handleSecondLevelDrilldown={this.handleSecondLevelDrilldown}
                Value_Label={this.props.Value_Label}
              />
            </SingleLevelDrilldown>
          </Grid>
        )}
        {this.state.secondLevelLocation === "drilldownOppId" && (
          <Grid
            item
            xs={12}
            style={{ position: "absolute", width: "100%", marginTop: "30px" }}
          >
            <SingleLevelDrilldown
              header={"Opportunity Change Events"}
              back={this.handleChangeLocationBack}
              stepBack={this.stepBack}
              filters={[]}
            >
              <ExpectedAcvPage
                body={this.props.ExpectedAcvData}
                Value_Label={this.props.Value_Label}
              />
            </SingleLevelDrilldown>
          </Grid>
        )}
      </Grid>
    );
  }
}
function mapStateToProps(state) {
  const {
    funnelCompareFilters,
    TeamAttainmentCleoData,
    persistentAlert,
    user,
    currentFilters,
    drilldownOnGraphData,
    ExpectedAcvData,
  } = state.app;
  return {
    funnelCompareFilters,
    currentFilters,
    drilldownOnGraphData,
    SegmentPerformanceData: TeamAttainmentCleoData ? TeamAttainmentCleoData.rowTotal : "",
    persistentAlert,
    company: user.company,
    Value_Label: user.Value_Label,
    TeamAttainmentCleoData: TeamAttainmentCleoData || "",
    ExpectedAcvData,
    helperTextCharts: user.elements.flatMap((item) => item.charts || []),
  };
}
const mapDispatchToProps = (dispatch) => ({
  getTeamAttainmentCleoData: (filters, key) => {
    dispatch({ type: "get_team_attainment_cleo_data_request" });
    dispatch({ type: "current_selected_filters", filters });
    appService.getTeamAttainmentCleoData(filters, key).then(
      (json) => {
        dispatch({ type: "get_team_attainment_cleo_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_team_attainment_cleo_data_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_team_attainment_cleo_data_failure", error });
      }
    );
  },
  getTeamAttainmentCleoFilters: () => {
    dispatch({ type: "get_funnelCompare_filters_request" });
    appService.getTeamAttainmentCleoFilters().then(
      (json) => {
        dispatch({ type: "get_funnelCompare_filters_success", json });
        dispatch({ type: "get_team_attainment_cleo_data_request" });
        const filters = [
          {
            name: "closed_fiscal_quarter",
            value: getDefaultSelectedFiscalQuarters(
              json.message,
              "closed_fiscal_quarter"
            ),
            string: true,
          },
        ];
        dispatch({ type: "current_selected_filters", filters });
        appService
          .getTeamAttainmentCleoData(
            json.message.length === 0 ? [] : filters,
            "closed_fiscal_quarter"
          )
          .then(
            (json) => {
              dispatch({ type: "get_team_attainment_cleo_data_success", json });
            },
            (error) => {
              if (typeof error === "object")
                dispatch({
                  type: "get_team_attainment_cleo_data_failure",
                  error: "Something went wrong",
                });
              else
                dispatch({ type: "get_team_attainment_cleo_data_failure", error });
            }
          );
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_funnelCompare_filters_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_funnelCompare_filters_failure", error });
      }
    );
  },
  getTeamAttainmentCleoDrilldown: (filters) => {
    dispatch({ type: "get_drilldown_on_graph_request" });
    appService.getTeamAttainmentCleoDrilldown(filters).then(
      (json) => {
        let tempOpportunities = json.message.opportunities[1].sort((a, b) =>
          a.ACV > b.ACV ? -1 : 1
        );
        tempOpportunities = tempOpportunities.map((item, index) => {
          let temp = {
            ...item,
            OppNo: index + 1,
          };
          return temp;
        });

        json.message = {
          ...json,
          columns: json.message.columns,
          count_acv: json.message.opportunities[0],
          opportunities: tempOpportunities,
        };

        dispatch({ type: "get_drilldown_on_graph_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_drilldown_on_graph_failure",
            error: "Something went wrong",
          });
        else dispatch({ type: "get_drilldown_on_graph_failure", error });
      }
    );
  },
  clearDrilldownData: () => {
    dispatch({ type: "clear_drilldown_data" });
  },
  getOpenOppData: (oppId) => {
    dispatch({ type: "get_expectedAcv_drilldown_data_request" });
    appService.getWaterfallOppData(oppId).then(
      (json) => {
        dispatch({ type: "get_expectedAcv_drilldown_data_success", json });
      },
      (error) => {
        if (typeof error === "object")
          dispatch({
            type: "get_expectedAcv_drilldown_data_failure",
            error: "Something went wrong",
          });
        else
          dispatch({ type: "get_expectedAcv_drilldown_data_failure", error });
      }
    );
  },
  clearExpectedAcvData: () => {
    dispatch({ type: "clear_expected_acv_data" });
  },
});

const connectedTeamAttainmentCleo = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(TeamAttainmentCleo));
export default connectedTeamAttainmentCleo;
